// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34P95","fullView":"styles_fullView__1aWd-"};